import { FC } from 'react';
import { CircularProgress, Stack } from '@mui/material';

const Loading: FC = () => {
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      sx={{
        backgroundColor: 'veil',
        backdropFilter: 'blur(5px)',
        position: 'fixed',
        left: '0',
        right: '0',
        top: '0',
        bottom: '0',
        width: '100%',
        height: '100%',
        zIndex: 10000,
        overflow: 'hidden',
      }}
    >
      <CircularProgress size={56} thickness={4} />
    </Stack>
  );
};

export default Loading;
